// @owners { team: patients-team }
import { MedDetails } from '@alto/features';
import { useNavigation } from '@alto/navigation';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useAddToCartInterstitialSheets } from '~web/features/checkout/hooks/useAddToCartInterstitialSheets';
import { useRemoveNotifications } from '~web/hooks';

type RouteParams = {
  readonly primaryPrescriptionId: string;
};

export const MedDetailsWrapper = () => {
  useRemoveNotifications();
  const { primaryPrescriptionId } = useParams<RouteParams>();
  const { getParam } = useNavigation<'RouteMedDetails'>();
  const origin = getParam('origin');

  return (
    <MedDetails
      origin={origin}
      primaryPrescriptionId={Number(primaryPrescriptionId)}
      // temporary until consolidating web & native's useAddToCartInterstitialSheets into RNW in features
      useAddToCartInterstitialSheets={useAddToCartInterstitialSheets}
    />
  );
};
